import React, { useMemo } from "react";
import whiteselectdown from "../../../images/whiteselectdown.svg";
import { Link } from "react-router-dom";
import { Filter, Star } from "lucide-react";

const DetailNavbar = ({ activeCategory, setActiveCategory }) => {
  // Define market categories
  const marketCategories = useMemo(
    () => [
      { name: "All", icon: null /*<Filter size={16} />*/ },
      { name: "Popular", icon: null /*<Star size={16} /> */ },
      { name: "Match", icon: null },
      { name: "Goals", icon: null },
      { name: "Handicap", icon: null },
      { name: "Player", icon: null },
      { name: "Inplay", icon: null },
      { name: "Team", icon: null },
      { name: "Marginal", icon: null },
      { name: "Specials", icon: null },
    ],
    []
  );
  return (
    <>
      {/*  */}
      <div className="sticky top-10 sm:top-12 md:top-20 xl:top-16 s15:top-16 s18:top-20 shadow-dashboardshadow sm:!rounded-[12px_12px_0_0] bg-bluedarkmode border-b border-doubleextralightwhite max-sm:mt-0 mt-3 s18:mt-[17px] z-10">
        <div className="relative">
          <Link
            to="/sports"
            className="absolute py-2 md:py-3 left-0 bg-bluedarkmode h-full w-10 flex items-center z-[2] cursor-pointer sm:!rounded-[12px_0_0_0]"
          >
            <img
              src={whiteselectdown}
              alt="whiteselectdown"
              className="w-3 ml-3 rotate-90"
            />
          </Link>
          <ul className="flex flex-row max-lg:justify-start items-center gap-3 overflow-x-auto scrollable pl-10">
            {marketCategories.map((category) => (
              <li
                onClick={() => setActiveCategory(category.name)}
                className={`inline-block uppercase whitespace-nowrap py-2 md:py-3 px-2 text-xs md:text-sm font-normal text-white hover:bg-darkblue ${
                  activeCategory === category.name
                }?"bg-darkblue":""`}
              >
                {category.icon}
                {category.name}
              </li>
              // <button
              //   key={category.name}
              //   onClick={() => setActiveCategory(category.name)}
              //   className={`px-4 py-2 whitespace-nowrap rounded-full flex items-center gap-1 ${
              //     activeCategory === category.name
              //       ? "bg-blue-500 text-white"
              //       : "bg-yellow text-gray-700 hover:bg-gray-200 dark:yellow dark:text-white"
              //   }`}
              // >

              // </button>
            ))}
          </ul>
        </div>
      </div>
      {/* </div> */}
    </>
  );
};

export default DetailNavbar;
